function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import comp2inline from 'computed-style-to-inline-style';
import './AVIChartTile.scss';
import { Base64 } from '../../utils/base64';
export var AVIChartTile = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AVIChartTile, _Component);

  function AVIChartTile(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.clearFilter = _this.clearFilter.bind(_assertThisInitialized(_this));
    _this.download = _this.download.bind(_assertThisInitialized(_this));
    _this.downloadPNG = _this.downloadPNG.bind(_assertThisInitialized(_this));
    _this.resize = _this.resize.bind(_assertThisInitialized(_this));
    _this.tileRef = React.createRef();

    if (typeof _this.props.getChart !== 'function') {
      throw new Error('Mandatory property getChart not set or invalid');
    }

    return _this;
  }

  var _proto = AVIChartTile.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('resize', this.resize);
    setTimeout(function () {
      var el = _this2.tileRef.current;
      _this2.renderedSize = {
        width: el.clientWidth,
        height: el.clientHeight
      };
    }, 100);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  };

  _proto.clearFilter = function clearFilter() {
    var getChart = this.props.getChart;

    if (getChart().hasFilter()) {
      getChart().filter(null).redrawGroup();
    }
  };

  _proto.getSvgXml = function getSvgXml(svg, preprocessFn) {
    // Get SVG
    var svgNode = svg.attr('title', escape(this.props.title)).attr('version', 1.1).attr('xmlns', 'http://www.w3.org/2000/svg').node(); // Let caller preprocess the SVG node before applying computed styles.

    preprocessFn && preprocessFn(svgNode);
    comp2inline(svgNode, {
      recursive: true,
      properties: ['box-sizing', 'color', 'display', 'flex', 'important', 'font-family', 'transform', 'translate', 'stroke', 'stroke-width', 'font-size', 'text-anchor', 'shape-rendering', 'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding', 'fill-opacity', 'opacity', 'fill']
    });
    return svgNode.parentNode.innerHTML;
  };

  _proto.download = function download(preprocessFn) {
    var _this$props = this.props,
        getChart = _this$props.getChart,
        title = _this$props.title;

    if (getChart()) {
      var svgElem = getChart().svg();

      if (svgElem) {
        var svgXml = this.getSvgXml(svgElem, preprocessFn); // Construct the <a> element

        var link = document.createElement('a');
        link.download = escape(title) + '.svg'; // NOTE: escape & unescape will be deprecated https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/unescape maybe use encodeURIComponent?
        // Construct the data uri

        var uri = 'data:text/csv;charset=utf-8;base64,' + Base64.encode(svgXml); // btoa will throw and error: Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.

        link.href = uri;
        document.body.appendChild(link);
        link.click(); // Cleanup the DOM

        document.body.removeChild(link); // Undo transformations

        getChart().render();
      }
    }
  };

  _proto.downloadPNG = function downloadPNG(preprocessFn) {
    var _this$props2 = this.props,
        getChart = _this$props2.getChart,
        title = _this$props2.title;

    if (getChart()) {
      var svgElem = getChart().svg();

      if (svgElem) {
        var svgXml = this.getSvgXml(svgElem, preprocessFn);
        var c = document.createElement('canvas');
        c.width = getChart().width() * 2;
        c.height = getChart().height() * 2;
        var ctx = c.getContext('2d');
        ctx.drawSvg(svgXml, 0, 0, getChart().width(), getChart().height()); // Construct the <a> element

        var link = document.createElement('a');
        link.download = escape(title) + '.png'; // Construct the data uri

        link.href = c.toDataURL();
        document.body.appendChild(link);
        link.click(); // Cleanup the DOM

        document.body.removeChild(link); // Undo transformations

        getChart().render();
      }
    }
  };

  _proto.resize = function resize() {
    var _this3 = this;

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(function () {
      var el = _this3.tileRef.current;
      var width = el.clientWidth;
      var height = el.clientHeight;

      if (_this3.renderedSize.width !== width || _this3.renderedSize.height !== height) {
        _this3.props.getChart().render();

        _this3.resizeTimeout = 0;
        _this3.renderedSize = {
          width: width,
          height: height
        };
      }
    }, 100);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props3 = this.props,
        children = _this$props3.children,
        title = _this$props3.title,
        getChart = _this$props3.getChart,
        showTools = _this$props3.showTools,
        ToolsComponent = _this$props3.toolsComponent;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.tileRef,
      className: 'avi-chart-tile chart-title'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart-tile-header chart-tile-header'
    }, /*#__PURE__*/React.createElement("h4", null, title)), /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart-tile-content chart-tile-content'
    }, children), showTools && (ToolsComponent ? /*#__PURE__*/React.createElement(ToolsComponent, {
      getChart: getChart,
      onClearFilter: this.clearFilter,
      onDownloadSVG: this.download,
      onDownloadPNG: this.downloadPNG
    }) : /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart-tile-footer chart-tile-footer'
    }, /*#__PURE__*/React.createElement("a", {
      className: 'avi-chart-action-link chart-action-link',
      onClick: function onClick(e) {
        e.stopPropagation();

        _this4.clearFilter();
      }
    }, "Tilbakestill"), /*#__PURE__*/React.createElement("span", {
      className: 'avi-chart-action-link chart-action-link'
    }, " \u2022 "), /*#__PURE__*/React.createElement("a", {
      className: 'avi-chart-action-link chart-action-link',
      onClick: function onClick(e) {
        e.stopPropagation();

        _this4.download();
      }
    }, "Last ned SVG"), /*#__PURE__*/React.createElement("span", {
      className: 'avi-chart-action-link chart-action-link'
    }, " \u2022 "), /*#__PURE__*/React.createElement("a", {
      className: 'avi-chart-action-link chart-action-link',
      onClick: function onClick(e) {
        e.stopPropagation();

        _this4.downloadPNG();
      }
    }, "Last ned PNG"))));
  };

  return AVIChartTile;
}(Component);

_defineProperty(AVIChartTile, "defaultProps", {
  showTools: true
});

AVIChartTile.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function returning the chart.
   */
  getChart: PropTypes.func.isRequired,

  /**
   * Chart title.
   */
  title: PropTypes.string,
  children: PropTypes.any,

  /** If true, tools to reset or download chart as SVG or PNG is shown. */
  showTools: PropTypes.bool,

  /**
   * If set, this component is rendered instead of standard tools.
   *
   * The following callbacks are provided as props:
   *
   * @param getChart Function returning the current chart.
   * @param onClearFilter Clear filter
   * @param onDownloadPNG Download chart as PNG
   * @param onDownloadSVG Download chart as SVG
   */
  toolsComponent: PropTypes.any
} : {};
export default {
  AVIChartTile: AVIChartTile
};